import { combineReducers } from 'redux';
import { Invitation, Organization } from '../../../types/entities';

import { invitations } from './invitations';
import { organizations } from './organizations';

export interface OrganizationsState {
  [id: string]: Organization;
}

export interface OrganizationState {
  invitations: Invitation[];
  organizations: OrganizationsState;
}

export const organization = combineReducers({
  invitations,
  organizations,
});
